import { useUpdateProposalProductOverridesMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateProposalProductOverrides() {
  const [mutation, { loading, data, error }] = useUpdateProposalProductOverridesMutation({
    refetchQueries: ["getProposal", "customGetProposal"],
    awaitRefetchQueries: true,
  });
  const [updateProposalProductOverrides, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateProposalProductOverrides",
    },
    {
      hideMessage: true,
    }
  );

  return [updateProposalProductOverrides, context] as const;
}
